// login action { getting authtokken }
export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';

// login action { getting user info. }
export const USER_DATA_REQUEST = 'USER_DATA_REQUEST';
export const USER_DETAIL_SUCCESS = 'USER_DETAIL_SUCCESS';
export const USER_DETAIL_FAIL = 'USER_DETAIL_FAIL';

// Signup action
export const USER_SIGNUP_REQUEST = 'USER_SIGNUP_REQUEST';
export const USER_SIGNUP_SUCCESS = 'USER_SIGNUP_SUCCESS';
export const USER_SIGNUP_FAIL = 'USER_SIGNUP_FAIL';

// user Logout
export const USER_LOGOUT = 'USER_LOGOUT';

// get all blogs
export const BLOGS_REQUEST = 'BLOGS_REQUEST';
export const BLOGS_REQUEST_SUCCESS = 'BLOGS_REQUEST_SUCCESS';
export const BLOGS_REQUEST_FAIL = 'BLOGS_REQUEST_FAIL';

// get all products
export const PRODUCTS_REQUEST = 'PRODUCTS_REQUEST';
export const PRODUCTS_REQUEST_SUCCESS = 'PRODUCTS_REQUEST_SUCCESS';
export const PRODUCTS_REQUEST_FAIL = 'PRODUCTS_REQUEST_FAIL';

// cart action by user
export const FETCH_CART = 'FETCH_CART';
export const GET_CART_BY_ID = 'GET_CART_BY_ID';
export const ADD_TO_CART = 'ADD_TO_CART';
export const CLEAN_CART = 'CLEAN_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const UPDATE_CART = 'UPDATE_CART';
export const MODIFY_CART = 'MODIFY_CART';

// Utils action
export const FETCH_SEARCH = 'FETCH_SEARCH';
export const SEARCH_RESULT = 'SEARCH_RESULT';
export const SEARCH_FAIL = 'SEARCH_FAIL';
export const FETCH_CONTACT_US = 'FETCH_CONTACT_US';
export const CONTACT_US_SUCCESS = 'CONTACT_US_SUCCESS';
export const CONTACT_US_FAIL = 'CONTACT_US_FAIL';

// Review actions
export const FETCH_REVIEWS = 'FETCH_REVIEWS';
export const REVIEWS_SUCCESS = 'REVIEWS_SUCCESS';
export const REVIEWS_FAIL = 'REVIEWS_FAIL';
export const SUBMIT_REVIEW = 'SUBMIT_REVIEW';
export const SUBMIT_REVIEW_SUCCESS = 'SUBMIT_REVIEW_SUCCESS';
export const SUBMIT_REVIEW_FAIL = 'SUBMIT_REVIEW_FAIL';

// Order action
export const FETCH_PLACE_ORDER = 'FETCH_PLACE_ORDER';
export const PLACE_ORDER_RESPONSE = 'PLACE_ORDER_RESPONSE';
export const PLACE_ORDER_FAIL = 'PLACE_ORDER_FAIL';
export const FETCH_GET_ORDERS = 'FETCH_GET_ORDERS';
export const GET_ORDERS_RESPONSE = 'GET_ORDERS_RESPONSE';
export const GET_ORDERS_FAIL = 'GET_ORDERS_FAIL';
export const FETCH_DELETE_ORDER = 'FETCH_DELETE_ORDER';
export const DELETE_ORDER_RESPONSE = 'DELETE_ORDER_RESPONSE';
export const DELETE_ORDER_FAIL = 'DELETE_ORDER_FAIL';